import React, { ReactNode, useState } from 'react';
import './Tooltip.scss';

interface TooltipProps {
  children: ReactNode;
  content: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

const Tooltip: React.FC<TooltipProps> = ({ children, content, position = 'top' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="custom-tooltip-wrapper"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div className={`custom-tooltip-box ${position}`}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
